import React from 'react'
import { Link } from 'gatsby'

class Navbar extends React.Component {

  state = {
    isActive: true,
    navBarActiveClass: ''
  }

  toggleMenu = () => {
    this.setState( state => ({ isActive: !state.isActive }) )
    this.setState( () => ({ navBarActiveClass: this.state.isActive ? 'is-active' : ''}) )
  }

  render() {
    const { lang } = this.props
    let indexLink, langLink, langString, menu

    if ( lang === "en" ) {
      indexLink = '/en/'
      langLink = '/'
      langString = 'Japanese'
      menu = [
        {
          'title': 'Research',
          'slug': '/en/research/'
        },
        {
          'title': 'Publications',
          'slug': '/en/publications/'
        },
        {
          'title': 'People',
          'slug': '/en/people/'
        },
        {
          'title': 'Contact',
          'slug': '/en/contact/'
        },
      ]
    } else {
      indexLink = '/'
      langLink = '/en/'
      langString = 'English'
      menu = [
        {
          'title': 'Research',
          'slug': '/research/'
        },
        {
          'title': 'Achievements',
          'slug': '/achievements/'
        },
        {
          'title': 'People',
          'slug': '/people/'
        },
        {
          'title': 'News',
          'slug': '/news/'
        },
        {
          'title': 'Contact',
          'slug': '/contact/'
        },
      ]
    }

    return (
      <nav className="navbar">
        <div className="navbar-contents">
          <div className="navbar-brand text-size-4">
            <Link className="navbar-item" to={indexLink}><p className="text-weight-bold">TANAKA</p>&nbsp;Lab</Link>
            <div
              className={ `navbar-burger ${this.state.navBarActiveClass}` }
              data-target="navMenu"
              onClick={ () => this.toggleMenu() }
              onKeyDown={ () => 0 }
              role="button"
              tabIndex={0}
            >
              <span />
              <span />
              <span />
            </div>
          </div>

          <div
            id='navMenu'
            className={ `navbar-menu ${ this.state.navBarActiveClass }` }
          >
            <div className="navbar-menu-right text-size-6">
              {
                menu.map( ({ title, slug }, idx) => {
                  return (<div className="navbar-item" key={idx}><Link className='navbar-item-hover' activeClassName='navbar-item-active' to={slug} >{title}</Link></div>)
                } )
              }
              <div className="navbar-item"><Link className='navbar-item-button' to={langLink}>{langString}</Link></div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navbar